/** Maximum number of simultaneous tabs allowed */
export const MAX_TABS = 12;
